import "./UserPermission.css";
import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
} from "react";
import { Link, useLocation } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { ToastContainer, toast } from "react-toastify";
// Reusable Components ------------------------------------
import ButtonCom from "../../../components/button/button";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import TableSkeleton from "../../../components/table/TableSkeleton.js";
// icons --------------------------------------------------
import { PiKeyLight } from "react-icons/pi";
// Redux actions ------------------------------------------
import {
  getRolePermissionsPath,
  saveRolePermissionsPath,
  getEmployeeInidvidualStaffListPath,
} from "../../../services/config";
import {
  commonGetDataOne,
  commonSaveData,
  commonSaveDataOne,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { fetchData, initRoleState } from "../../../redux/slices/roleSlice";
import { useDispatch, useSelector } from "react-redux";
import { HasPermission } from "../../../services/hasPermission";
import RolePermission from "../../../components/RolePermission/rolePermission.js";
// Constant data ------------------------------------------

// Current Component --------------------------------------
const UserPermission = ({ user, user_details }) => {
  const userData = JSON.parse(localStorage.getItem("user_data")) || {};
  const gridRef = useRef();
  const dispatch = useDispatch();

  const state = useSelector((state) => state.roles);
  const commonStore = useSelector((state) => state.common);

  const [userDetails, setUserDetails] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [filteredPermissions, setFilteredPermissions] = useState([]);

  const [staffId, setStaffId] = useState("");
  const [activeKey, setActiveKey] = useState("");
  const [activeRole, setActiveRole] = useState("");

  const getUserDetails = useCallback(() => {
    const url = `${getEmployeeInidvidualStaffListPath}${localStorage.getItem(
      "employee-id"
    )}`;
    dispatch(commonGetDataOne(url));
  }, []);

  const fetchRolePermissions = useCallback((roleId) => {
    let data = {
      path: getRolePermissionsPath,
      data: {
        staffId: user_details[0].staffId,
        userId: userData.user_id,
        roleId: "",
        designationId: user_details[0].designationId,
      },
    };
    dispatch(commonSaveData(data));
    dispatch(fetchData());
  }, []);

  useEffect(() =>  {
    getUserDetails();
  }, []);

  useEffect(() => {
    if (commonStore.commonGetOneSuccess) {
      setUserDetails(commonStore.commonGetOneData);
      setActiveKey(commonStore.commonGetOneData[0].emp_role);
      setActiveRole(commonStore.commonGetOneData[0].emp_role);
      setTimeout(() => {
        fetchRolePermissions(commonStore.commonGetOneData[0].emp_role);
      }, 100);
    }
    if (commonStore.commonSuccess) {
      setPermissions(commonStore.commonData);
      setFilteredPermissions(commonStore.commonData);
      dispatch(initCommonState());
    }
    if (commonStore.commonSuccessOne) {
      toast.success(commonStore.commonMessageOne);
      fetchRolePermissions(1);
      getUserDetails();
      dispatch(initCommonState());
    }
    if (commonStore.commonErrorOne) {
      toast.error(commonStore.commonMessageOne);
      dispatch(initCommonState());
    }
    if (state.roleGetSuccess) {
      setRoleList(state.roleGetData);
      dispatch(initRoleState());
    }
  }, [commonStore, state, dispatch]);

  return (
    <div style={{ paddingLeft: "10px", marginBottom: "15px" }}>
      <Widgets
        // icon={
        //   permissions?.length < 1 && (
        //     <WidgetsIcon icon={<PiKeyLight />} title="User Permissions" />
        //   )
        // }
        // button={
        //   HasPermission("Employee", "edit") &&
        //   permissions?.length > 0 && (
        //     <ButtonCom
        //       type={"button"}
        //       class_name={"p_btn universal-btn"}
        //       text="Save Changes"
        //       url_or_onclick={saveChanges}
        //       icon={null}
        //       width={""}
        //     />
        //   )
        // }
        body={
          <div
            style={{
              height: "calc(100vh - 150px)",
              width: "100%",
              overflow: "hidden",
              position: "relative",
              top: "-25px",
            }}
          >
            {commonStore.commonLoading && <TableSkeleton />}
            {permissions?.length > 0 ? (
              <div
                style={{
                  height: "calc(100vh - 130px)",
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",
                  paddingBottom: "100px",
                  marginBottom: "100px",
                }}
              >
                <RolePermission
                  user={user}
                  designationId={user_details[0].designationId}
                  saveMasterRolePermissionsPath={saveRolePermissionsPath}
                  dispatch={dispatch}
                  commonSaveData={commonSaveDataOne}
                  initialData={permissions}
                  handleModalClose1={null}
                  staffId={user_details[0].staffId}
                  isPopup={false}
                  isEdit={HasPermission("User Permission", "edit")}
                />
              </div>
            ) : (
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "calc(100vh - 200px)",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "60%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                   
                  }}
                  className="color-white"
                >
                  No Data found!
                </span>
              </div>
            )}

            {/* <AgGridReact
              ref={gridRef}
              rowData={
                permissions?.length > 0
                  ? permissions.map((p) => ({ ...p }))
                  : []
              }
              columnDefs={heading}
              immutableData={true} // Important!
              getRowNodeId={(data) => data.id}
              suppressCellFocus={true}
            /> */}
          </div>
        }
      />
    </div>
  );
};

export default UserPermission;
